export default __webpack_public_path__ + "static/media/jewelery.778ae7f1.svg";